export class registerModel {
  
    constructor(
      public mail: string,
      public username: string, 
      public passw: string,
    ) {  }
  
  }


// WEBPACK FOOTER //
// ./src/app/create-workspace/http-post-request-object-classes/registerModel.ts